import React, { useEffect, useState } from "react";
import TasksEverydayCkeck from "./TasksEverydayCkeck";
import _ from "lodash";
import submit from "submit-form";
import { shallowEqual } from "../../../../utils/daily-accountability";
import SvgIcon from "../../../../parts/SvgIcon";
const weekDays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

const Tasks = ({
  athlete,
  activeUserToRequest,
  coachOrganizationInformation,
  active,
}) => {
  const referAsClients = activeUserToRequest?.referAsClients || false;
  const [initialState, setInitialState] = useState({});
  const stateKeys = [
    "questionnaire",
    "progressPic",
    "bodyweight",
    "bodyMeasurements",
  ];
  const getInitialState = (athlete) => {
    if (athlete.tasks) return athlete.tasks;
    const initialState = {};
    stateKeys.forEach((key) => {
      const obj = {};
      weekDays.forEach((day) => (obj[day] = false));
      initialState[key] = obj;
    });
    return initialState;
  };
  const tasksList = [
    {
      key: "questionnaire",
      icon: "vuesax-linear-heart-add.svg",
      title: "Fill out readiness questionnaire",
    },
    {
      key: "progressPic",
      icon: "vuesax-linear-camera.svg",
      title: "Upload progress pictures",
    },
    {
      key: "bodyweight",
      icon: "vuesax-linear-weight.svg",
      title: "Upload bodyweight",
    },
    {
      key: "bodyMeasurements",
      icon: "vuesax-linear-ruler.svg",
      title: "Upload body measurements",
    },
  ];
  const [canSubmit, setCanSubmit] = React.useState(false);
  const [state, setState] = React.useState(getInitialState(athlete));
  const handleCheck = (key, day) => {
    setState((prevState) =>
      Object.assign({}, prevState, {
        [key]: Object.assign({}, prevState[key], {
          [day]: !prevState[key][day],
        }),
      })
    );
  };
  const replacer = (key, value) => {
    if (typeof value === "boolean") {
      return value ? true : false; // convert boolean to JSON representation
    }
    return value; // leave other values unchanged
  };
  const handleSubmit = () => {
    let body = state;
    if (coachOrganizationInformation) {
      body = { ...body, coachOrganizationInformation };
    }
    submit(`/actions/user/update-athlete-tasks/${athlete._id}`, {
      method: "POST",
      options: { bodyBuilder: { replacer } },
      body,
    });
  };
  React.useEffect(() => {
    setInitialState(getInitialState(athlete));
    setState(getInitialState(athlete));
  }, [athlete]);
  const compareChanges = (obj1, obj2) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    let changed = false;
    keys1.forEach((key) => {
      if (!changed) {
        if (!shallowEqual(obj1[key], obj2[key])) changed = true;
      }
    });
    return changed;
  };
  useEffect(() => {
    if (compareChanges(state, initialState)) setCanSubmit(true);
    else setCanSubmit(false);
  }, [state]);
  return (
    <div role="tasks-container">
      <header>
        <h4>Tasks</h4>
        <p className="p5">
          Create daily tasks for your{" "}
          {referAsClients ? "client's" : "athlete's"} to upload data to help you
          coach better
        </p>
      </header>
      <section>
        <header className="Profile-Tasks-Line mobile-hidden">
          <p className="p4">Tasks</p>
          <hgroup className="Tasks-Right-Col">
            <div className="Tasks-Day-Item">Everyday</div>
            {weekDays.map((day) => (
              <div className="Tasks-Day-Item">{_.capitalize(day)}</div>
            ))}
          </hgroup>
        </header>

        {tasksList.map((item) => {
          return (
            <div className="Profile-Tasks-Line">
              <div className="Tasks-Left-Col">
                <SvgIcon src={`/img/new-icons/${item.icon}`} />
                <div>{item.title}</div>
              </div>
              <div className="Tasks-Right-Col">
                <TasksEverydayCkeck
                  task={item.key}
                  state={state}
                  setState={setState}
                />
                <TaskScheduler
                  item={item}
                  weekDays={weekDays}
                  state={state}
                  handleCheck={handleCheck}
                />
              </div>
            </div>
          );
        })}
      </section>
      <button
        onClick={canSubmit ? handleSubmit : null}
        data-button-type="primary"
        disabled={canSubmit ? undefined : true}
      >
        Save
      </button>
    </div>
  );
};
/**
 * Days to show in mobile devices
 * @param {*} param0
 * @returns
 */
const TaskDaysMobile = ({ item, weekDays, state, handleCheck }) => (
  <div className="tasks-mobile-days force-only-show-mobile">
    {weekDays?.map((day, index) => (
      <div
        key={index}
        className={state[item.key][day] ? "p4 task-day active" : "p4 task-day"}
        onClick={() => handleCheck(item.key, day)}
      >
        {day.charAt(0).toUpperCase()}
      </div>
    ))}
  </div>
);

/**
 * Days to show in desktop
 * @param {*} param0
 * @returns
 */
const TaskDaysDesktop = ({ item, weekDays, state, handleCheck }) => (
  <>
    {weekDays.map((day, index) => {
      const iconSrc = state[item.key][day]
        ? "/img/new-icons/vuesax-linear-tick-circle-gradient.svg"
        : "/img/new-icons/vuesax-linear-tick-circle.svg";
      const noFilterOnLight = state[item.key][day] ? true : false;
      return (
        <SvgIcon
          key={index}
          src={iconSrc}
          onClick={() => handleCheck(item.key, day)}
          noFilterOnLight={noFilterOnLight}
          classNames="force-mobile-hidden"
        />
      );
    })}
  </>
);

const TaskScheduler = ({ item, weekDays, state, handleCheck }) => (
  <>
    {state[item.key] && (
      <TaskDaysDesktop
        item={item}
        weekDays={weekDays}
        state={state}
        handleCheck={handleCheck}
      />
    )}
    {state[item.key] && (
      <TaskDaysMobile
        item={item}
        weekDays={weekDays}
        state={state}
        handleCheck={handleCheck}
      />
    )}
  </>
);

module.exports = Tasks;
